import React  from 'react';
import PageLayout from '../components/Layouts/PageLayout';
import { MainData } from '../Data/MainData';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { getLanLoc } from '../components/Functions/LangFunc';
import styled from 'styled-components';
import PageBuilder from '../components/PageBuilder/PageBuilder';

const Styles = styled.div`
  display: flex;
  flex-direction: column;
`

export default function VisaPage (props){
  const location = useLocation();
  const params = useParams()
  let {isEn: lan, isSet: isSetLan} = getLanLoc(location.pathname);
  if(!isSetLan){
    return (
      <Navigate replace={true} to={"/en/" + location.pathname}/>
    )
  }
  return (
    <PageLayout 
      {...props} 
      language={lan ? {...MainData.dict[0]} : {...MainData.dict[1]}} 
      dict={MainData.dict} 
      mainLogo={MainData.mainLogo} 
      texts={MainData.texts} 
      nav={MainData.nav} 
      footer={MainData.footer} 
      login={MainData.login}
    >
      <Styles>
        <PageBuilder {...props} lan={(lan ? MainData.dict[0] : MainData.dict[1])} vars={{Country_Url: params.country}} page={"visa_template_" + (lan ? MainData.dict[0].filename : MainData.dict[1].filename)}/>
      </Styles>
    </PageLayout>
  )
}

